const approverStatusEnum = {
    worker: 1,
    visager: 2,
    viewer: 3,
}

export default approverStatusEnum